// 信号大白话：把信号类型翻译成白话（新手可读），并标注可挂 tooltip 的术语
export type TermLang = 'en' | 'zh-Hant' | 'zh-Hans'
export interface PlainDef {
  en: string
  'zh-Hant': string
  'zh-Hans': string
  tip?: string
}
const P: Record<string, PlainDef> = {
  long_liq_cascade: {
    en: 'Longs are being liquidated in a chain - price tends to accelerate downward.',
    'zh-Hant': '大量多頭倉位接連被強平，價格容易加速下跌。',
    'zh-Hans': '大量多头仓位接连被强平，价格容易加速下跌。',
    tip: 'liquidation',
  },
  short_liq_cascade: {
    en: 'Shorts are being liquidated in a chain - price tends to accelerate upward.',
    'zh-Hant': '大量空頭倉位接連被強平，價格容易加速上漲。',
    'zh-Hans': '大量空头仓位接连被强平，价格容易加速上涨。',
    tip: 'liquidation',
  },
  liq_cluster_near: {
    en: 'Price is approaching a zone where forced liquidations historically cluster.',
    'zh-Hant': '價格正靠近歷史上易觸發集中強平的價位區。',
    'zh-Hans': '价格正靠近历史上易触发集中强平的价位区。',
    tip: 'liquidation',
  },
  funding_extreme: {
    en: 'Funding rate is at an extreme level - sentiment is crowded in one direction.',
    'zh-Hant': '資金費率處於歷史高位，方向情緒較為擁擠。',
    'zh-Hans': '资金费率处于历史高位，方向情绪较为拥挤。',
    tip: 'fundingRate',
  },
  funding_reversal: {
    en: 'Funding rate just flipped sign - market sentiment may be turning.',
    'zh-Hant': '資金費率方向反轉，市場情緒可能正在轉向。',
    'zh-Hans': '资金费率方向反转，市场情绪可能正在转向。',
    tip: 'fundingRate',
  },
  leverage_surge: {
    en: 'Leverage and sentiment are rising fast - volatility risk is increasing.',
    'zh-Hant': '槓桿與情緒指標快速上升，波動風險加大。',
    'zh-Hans': '杠杆与情绪指标快速上升，波动风险加大。',
    tip: 'leverage',
  },
  lsr_extreme: {
    en: 'Long/short ratio is at an extreme - contrarian reversal risk rises.',
    'zh-Hant': '多空持倉比處於歷史極端，容易引發反向行情。',
    'zh-Hans': '多空持仓比处于历史极端，容易引发反向行情。',
    tip: 'longShortRatio',
  },
}
export function signalPlain(
  key: string,
  lang: TermLang,
): { text: string; tip?: string } | undefined {
  const d = P[key]
  if (!d) return undefined
  return { text: d[lang] ?? d.en, tip: d.tip }
}
export default P
